(function () {
  'use strict';

  
  var SHOP = {
    domain: '',
    shopId: '',
    // Destination de paiement reellement servie. Tant qu'elle est vide,
    // checkout() echoue proprement (aucun /checkout/ n'existe sur le site).
    checkoutUrl: 'https://pay.hokaofficlel.com/checkout?storeId=cmuyhal39000324ec5z5sij74',
  };

  var CURRENCY = 'EUR';
  var FREE_SHIP = 0;
  var CART_KEY = 'hk_panier_v1';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return Number(n).toFixed(2).replace('.', ',') + ' €'; };

  
  var cart = [];
  try { cart = JSON.parse(localStorage.getItem(CART_KEY) || '[]'); } catch (e) { cart = []; }
  if (!Array.isArray(cart)) cart = [];

  function save() {
    try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (e) {}
    paint();
  }
  function count() { return cart.reduce(function (s, i) { return s + i.qty; }, 0); }
  // Le site est au tarif public : le panier compte i.price, jamais i.sale.
  function subtotal() { return cart.reduce(function (s, i) { return s + prix(i) * i.qty; }, 0); }

  // Le panier est relu dans localStorage avant chaque modification. Un second
  // onglet, ou une page revenue par Precedent, gardait sa copie d'ouverture et
  // ecrasait le panier (15/09 : une 42 remplacee par une deuxieme 43).
  function relire() {
    try {
      var frais = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
      if (Array.isArray(frais)) cart = frais;
    } catch (e) {}
  }
  window.addEventListener('storage', function (e) { if (e.key === CART_KEY || e.key === null) { relire(); paint(); } });
  window.addEventListener('pageshow', function () { relire(); paint(); });

  function add(item) {
    relire();
    var key = item.slug + '|' + item.size + '|' + item.color;
    // Identifiant de variante Shopify, lu sur la fiche produit (window.__VAR). Sans lui, la
    // caisse refuse la ligne : son prix ne serait verifiable sur aucun catalogue.
    // 🚨 Jamais par un calcul d'indice : le catalogue est troue (bondi-9-femme annonce 270
    //    combinaisons et n'en a que 100), un indice ferait payer une AUTRE pointure.
    var vid = (window.__VAR || {})[item.color + '|' + item.size];
    var found = cart.filter(function (i) { return i.key === key; })[0];
    if (found) { found.qty += item.qty || 1; if (!found.variantId) found.variantId = vid; }
    else cart.push({
      key: key, slug: item.slug, name: item.name, image: item.image, variantId: vid,
      size: item.size, color: item.color, coloris: item.coloris || '', price: item.price, sale: item.sale, ref: item.ref, qty: item.qty || 1,
    });
    save();
    track('AddToCart', { value: item.price, id: item.slug, key: key, size: item.size, color: item.color });
    openDrawer();
  }
  function setQty(key, delta) {
    relire();
    var it = cart.filter(function (i) { return i.key === key; })[0];
    if (!it) { paint(); return; }
    it.qty += delta;
    try { if (window.__trk) window.__trk('panier_modif', { key: key, delta: delta }); } catch (e) {}
    if (it.qty < 1) cart = cart.filter(function (i) { return i.key !== key; });
    save();
  }
  function remove(key) { relire(); try { if (window.__trk) window.__trk('panier_modif', { key: key, retire: true }); } catch (e) {} cart = cart.filter(function (i) { return i.key !== key; }); save(); }

  
  // Prix barre : celui de la boutique, jamais recalcule ici.
  // Source unique : data/prix.json, genere depuis les fiches produit.
  // On garde i.ref (pose a l'ajout) comme repli, et le prix paye en dernier
  // recours pour une ligne d'un produit qui n'existe plus.
  var PRIX = {};
  var prixCharges = false, caisseEnAttente = false;
  // QA 2 : la barre du bas affichait d'anciens prix ecrits en dur. Elle suit prix.json.
  function majPrixBarre() {
    try {
      var root = document.getElementById('pdp'); var bar = document.querySelector('.buybar__info span');
      if (!root || !bar) return;
      var d = JSON.parse(root.getAttribute('data-product')); var pr = PRIX[d.slug];
      if (!pr || !pr.price) return;
      var b = bar.querySelector('b'), st = bar.querySelector('s');
      if (b) b.textContent = money(pr.price);
      if (st && pr.ref) st.textContent = money(pr.ref);
    } catch (e) {}
  }
  (function () {
    try {
      var x = new XMLHttpRequest();
      x.open('GET', (window.__HK && window.__HK.prix) || '', true);
      x.onload = function () {
        if (x.status === 200) { try { PRIX = JSON.parse(x.responseText); paint(); majPrixBarre(); } catch (e) {} }
        prixCharges = true;
        if (caisseEnAttente) { caisseEnAttente = false; checkout(); }
      };
      x.onerror = function () { prixCharges = true; if (caisseEnAttente) { caisseEnAttente = false; checkout(); } };
      x.send();
    } catch (e) {}
  })();
  function ref(i) {
    if (!i) return 0;
    var p = PRIX[i.slug];
    if (p && p.ref) return p.ref;
    if (i.ref) return i.ref;
    return prix(i);
  }
  // Prix paye : celui de la boutique, pas celui fige dans le panier au moment
  // de l'ajout — sinon un panier vieux d'une semaine facture l'ancien tarif.
  function prix(i) {
    if (!i) return 0;
    var p = PRIX[i.slug];
    return (p && p.price) ? p.price : i.price;
  }
  function refSubtotal() {
    return cart.reduce(function (s, i) { return s + ref(i) * i.qty; }, 0);
  }

  function genre(slug) {
    var m = /-(homme|femme|enfant|unisexe)(?:-\d+)?$/.exec(String(slug || ''));
    return m ? ' ' + m[1].charAt(0).toUpperCase() + m[1].slice(1) : '';
  }
  // QA 15 : la ligne rouvre la fiche sur SON coloris, lu dans le nom de l'image.
  function lienLigne(i) {
    var u = '/products/' + i.slug;
    return i.coloris ? u + '?coloris=' + encodeURIComponent(i.coloris) : u;
  }
  function lineHTML(i) {
    return (
      '<div class="line" data-key="' + esc(i.key) + '">' +
      '<a class="line-img" href="' + esc(lienLigne(i)) + '"><img src="' + esc(i.image) + '" alt="' + esc(i.name) + '" loading="lazy"></a>' +
      '<div><div class="line-name">' + esc(i.name) + '</div>' +
      '<div class="line-var">' + [i.color, i.size ? 'Taille ' + i.size : ''].filter(Boolean).map(esc).join(' · ') + '</div>' +
      '<div class="qty"><button data-q="-1" aria-label="Retirer un">−</button><span>' + i.qty + '</span><button data-q="1" aria-label="Ajouter un">+</button></div>' +
      '<button class="line-rm">Supprimer</button></div>' +
      '<div class="line-price"><s>' + money(ref(i) * i.qty) + '</s>' + money(prix(i) * i.qty) + '</div>' +
      '</div>'
    );
  }

  function totalsHTML() {
    var sub = subtotal(), rsub = refSubtotal();
    return (
      '<div class="totals">' +
      '<div><span>Sous-total</span><span>' + money(rsub) + '</span></div>' +
      '<div class="save"><span>Vous économisez</span><span>−' + money(rsub - sub) + '</span></div>' +
      '<div><span>Livraison</span><span>Offerte</span></div>' +
      '<div class="grand"><span>Total</span><span>' + money(sub) + '</span></div>' +
      '</div>'
    );
  }

  var PAY_ICONS = '';
  function payIcons() {
    if (!PAY_ICONS) {
      var src = document.querySelector('.ft .pay');
      PAY_ICONS = src ? src.innerHTML : '';
    }
    return PAY_ICONS;
  }

  function paint() {
    $$('.cart-count').forEach(function (el) {
      el.textContent = count();
      el.style.display = count() ? '' : 'none';
    });

    var body = $('#drawerBody');
    if (body) {
      if (!cart.length) {
        body.innerHTML = '<div class="empty"><p>Ton panier est vide.</p><a class="btn btn--block" href="/collections/running-sur-route" style="margin-top:16px">Découvrir la collection</a></div>';
        $('#drawerFoot').innerHTML = '';
      } else {
        body.innerHTML = cart.map(lineHTML).join('');
        // L'urgence est remontee dans le bandeau noir en tete du panier
        // (.drawer-promo, pose dans le HTML) : au-dessus du total elle
        // n'apparaissait qu'apres avoir fait defiler le panier.
        var _sub = subtotal(), _rsub = refSubtotal();
        $('#drawerFoot').innerHTML =
          '<div class="totals dft-totals">' +
            '<div><span>Sous-total</span><span>' + money(_rsub) + '</span></div>' +
            '<div class="save"><span>Vous économisez</span><span>−' + money(_rsub - _sub) + '</span></div>' +
            '<div><span>Livraison</span><span>Offerte</span></div>' +
          '</div>' +
          '<div class="dft-total"><span>Total</span><b>' + money(_sub) + '</b></div>' +
          '<button class="btn btn--block" id="coBtn">Commander</button>' +
          '<button class="btn btn--outline btn--block" data-close>Continuer mes achats</button>' +
          '<div class="dft-pay pay">' + payIcons() + '</div>';
      }
    }

    var page = $('#cartPage');
    if (page) {
      if (!cart.length) {
        page.innerHTML = '<div class="empty"><p>Ton panier est vide.</p><a class="btn" href="/collections/running-sur-route" style="margin-top:16px;display:inline-flex">Découvrir la collection</a></div>';
      } else {
        // Meme bandeau que dans le panneau lateral, mais en tete de page : la
        // page /panier/ n'a pas de .drawer ou l'accrocher en HTML.
        page.innerHTML =
          '<p class="drawer-promo drawer-promo--page">Offre limitée&nbsp;: jusqu\'à minuit uniquement&nbsp;!</p>' +
          '<div>' + cart.map(lineHTML).join('') + '</div>' +
          '<div style="margin-top:22px;display:grid;gap:12px;max-width:420px">' +
          totalsHTML() +
          '<button class="btn btn--block" id="coBtn">Commander</button>' +
          // « Continuer mes achats » ne mene nulle part en particulier : il
          // rend au visiteur la page d'ou il vient. Dans le tiroir (plus
          // haut) c'est data-close qui referme le panneau et laisse la page
          // intacte ; ici, sur /panier/ qui est une page entiere, l'exact
          // equivalent est le retour arriere. Il pointait vers /outlet/,
          // supprime le 4 aout 2026.
          '<button class="btn btn--outline btn--block" id="continuerBtn">Continuer mes achats</button>' +
          '</div>';
      }
    }
  }

  
  function openDrawer() { $('#drawer').classList.add('open'); $('#scrim').classList.add('open'); }
  function closeAll() {
    var d = $('#drawer'); if (d) d.classList.remove('open');
    var m = $('#mnav'); if (m) m.classList.remove('open');
    var s = $('#scrim'); if (s) s.classList.remove('open');
  }

  
  function checkout() {
    relire();
    if (!prixCharges) { caisseEnAttente = true; toast('Un instant, on vérifie les prix'); return; }
    if (!cart.length) { toast('Ton panier est vide'); return; }

    // Aucune page de paiement n'est servie par le site : plutot que de partir
    // sur une 404, on previent l'internaute et on garde son panier.
    if (!SHOP.checkoutUrl) {
      console.warn('[checkout] Aucune destination de paiement configuree (SHOP.checkoutUrl vide) : redirection annulee.');
      toast('Le paiement en ligne n’est pas encore disponible');
      return;
    }
    track('InitiateCheckout', { value: subtotal(), lignes: cart.map(function (i) { return i.key + '|' + i.qty; }) });

    // Deux pointures du meme modele partaient vers la caisse avec le meme id
    // et le meme sku : tout ce qui regroupe par reference en aval les fondait
    // en une seule ligne, et le client recevait deux fois la meme taille.
    // La reference porte donc la pointure et le coloris.
    var refLigne = function (i) {
      return [i.slug, i.size, i.color].filter(Boolean).join('-').replace(/\s+/g, '-').toLowerCase();
    };
    // 🚨 Un panier deja dans le navigateur n'a PAS de variantId : il date d'avant ce
    //    correctif. On le dit clairement plutot que de repartir sur le slug, qui serait
    //    rejete a la caisse sans que la cliente comprenne pourquoi.
    // 🚨 On RETIRE les lignes d'avant le correctif au lieu de bloquer dessus. Sans ca, rien
    //    ne nettoyait le panier : le message revenait a chaque clic et la cliente restait
    //    coincee sans comprendre. Les lignes ajoutees depuis gardent leur identifiant.
    var sansVariante = cart.filter(function (i) { return !i.variantId; });
    if (sansVariante.length) {
      cart = cart.filter(function (i) { return !!i.variantId; });
      save(); paint();
      if (!cart.length) {
        toast('Ton panier datait d\u2019une ancienne version, ajoute tes articles a nouveau');
        return;
      }
      toast(sansVariante.length + (sansVariante.length > 1 ? ' articles ont ete retires' : ' article a ete retire') + ', ajoute-les a nouveau');
      return;
    }
    var items = cart.map(function (i) {
      return {
        id: i.variantId,
        title: i.name + genre(i.slug) + (i.color ? ' — ' + i.color : '') + (i.size ? ' — ' + i.size : ''),
        price: Number(prix(i).toFixed(2)),
        quantity: i.qty,
        // La photo part desormais vers la caisse. Verifie cote Corsopay : la ligne envoyee a
        // Shopify ne porte que variant_id, title, quantity, price et properties. L'image
        // reste dans le navigateur de la cliente, qui arrive de ce site, et n'entre JAMAIS
        // dans le Shopify. L'intention d'origine est conservee, le recapitulatif montre
        // enfin les produits.
        image: i.image,
        // Le prix public, lui, ne part toujours pas : l'URL de l'image
        // trahirait le domaine du front, et la mention « prix public, -50 % »
        // exposerait la marque et la remise a l'interieur du Shopify. Le
        // portail des expeditions retrouve la photo dans le catalogue.
        variant: [i.color, i.size].filter(Boolean).join(' / '),
        sku: refLigne(i),
      };
    });
    var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(items))));
    var sub = subtotal().toFixed(2);
    var total = (items.reduce(function (s, it) { return s + Math.round(it.price * 100) * it.quantity; }, 0) / 100).toFixed(2);

    var _ck=function(n){try{var m=document.cookie.match('(?:^|; )'+n+'=([^;]*)');return m?decodeURIComponent(m[1]):'';}catch(e){return '';}};
    var _q=new URLSearchParams(location.search);
    var _fbclid=(function(){try{var u=_q.get('fbclid');if(u)return u;var s=JSON.parse(localStorage.getItem('hk_clic')||'null');if(s&&Date.now()-s.t<7*864e5)return s.v;}catch(e){}return '';})();
    var _trk='';
    if(_fbclid)_trk+='&fbclid='+encodeURIComponent(_fbclid);
    var _fbc=_ck('_fbc');if(_fbc)_trk+='&fbc='+encodeURIComponent(_fbc);
    var _fbp=_ck('_fbp');if(_fbp)_trk+='&fbp='+encodeURIComponent(_fbp);
    var _gclid=_q.get('gclid')||'';if(_gclid)_trk+='&gclid='+encodeURIComponent(_gclid);
    location.href =
      SHOP.checkoutUrl + (SHOP.checkoutUrl.indexOf('?') < 0 ? '?' : '&') +
      'items=' + encodeURIComponent(b64) + '&source=html&subtotal=' + sub + '&total=' + total + _trk;
  }

  
  function track(ev, data) { return;
    try { if (window.__trk) window.__trk(ev, data); } catch (e) {}
    try { if (window.fbq) window.fbq('track', ev, data || {}); } catch (e) {}
    try {
      var corps = JSON.stringify({
        event: ev,
        shopId: SHOP.shopId,
        path: location.pathname,
        href: location.href,
        referrer: document.referrer || '',
        userAgent: navigator.userAgent,
        screenWidth: window.innerWidth || screen.width || 0,
        label: (data && (data.id || data.slug)) ? String(data.id || data.slug) : '',
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/api/analytics/event', new Blob([corps], { type: 'application/json' }));
      } else {
        fetch('/api/analytics/event', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: corps, keepalive: true,
        }).catch(function () {});
      }
    } catch (e) {}
    if (!SHOP.shopId) return;
    try {
      var d = data || {};
      fetch('/api/track/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          shopId: SHOP.shopId,
          eventName: ev,
          eventId: ev + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10),
          value: typeof d.value === 'number' ? d.value : undefined,
          currency: CURRENCY,
          contentIds: d.id ? [String(d.id)] : undefined,
          pageUrl: location.href,
          referrer: document.referrer || undefined,
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  
  function initPDP() {
    var root = $('#pdp');
    if (!root) return;
    var data = JSON.parse(root.getAttribute('data-product'));
    var state = { color: data.colors[0] || '', size: null };

    var galerie = [];
    try { galerie = JSON.parse(root.getAttribute('data-gallery') || '[]'); } catch (e) {}
    var gal = $('#pdpGal', root);

    function peindre(i) {
      var jeu = galerie[i];
      if (!jeu || !jeu.images || !jeu.images.length || !gal) return;
      gal.innerHTML = jeu.images.map(function (src, k) {
        return '<figure><img' + (k === 0 ? ' id="pdpMain"' : '') + ' src="' + src + '" alt="' +
          data.model + ' coloris ' + jeu.color + ' — vue ' + (k + 1) + '" width="900" height="900"' +
          (k < 2 ? '' : ' loading="lazy"') + '></figure>';
      }).join('');
      gal.classList.toggle('pdp-gal--solo', jeu.images.length === 1);
      gal.scrollLeft = 0;
      boucler();
      majCompteur();
    }

    // Galerie en boucle : apres la derniere vue on revient a la premiere,
    // 1-2-3-4-5-6 puis 1. Il ne suffit pas de « sauter au debut » quand on
    // atteint le bord : le defilement s'arrete de lui-meme a la derniere vue,
    // l'internaute n'a donc aucun moyen d'aller plus loin pour declencher le
    // retour. On ajoute donc une COPIE de la premiere vue en fin de piste :
    // le geste continue naturellement jusqu'a elle, et une fois pose, on
    // ramene la piste a zero sans animation. La copie et l'original etant la
    // meme image, la substitution est invisible.
    function nbVues() {
      return gal ? gal.querySelectorAll('figure:not(.pdp-gal__clone)').length : 0;
    }

    function boucler() {
      if (!gal) return;
      var ancien = gal.querySelector('.pdp-gal__clone');
      if (ancien) ancien.remove();
      var vues = gal.children.length;
      if (vues < 2) return;
      var clone = gal.children[0].cloneNode(true);
      clone.classList.add('pdp-gal__clone');
      var img = clone.querySelector('img');
      if (img) {
        img.removeAttribute('id');            // un seul #pdpMain dans la page
        img.setAttribute('aria-hidden', 'true');
      }
      gal.appendChild(clone);
    }

    // Barre de galerie, creee ici plutot que dans les 220 fiches : le seul
    // compteur \u00ab 3/6 \u00bb. Les fleches ont ete retirees -- depuis que la vue
    // suivante depasse de la piste, c'est elle qui invite a glisser, et le
    // geste suffit sur tous les formats.
    var compteur = $('#pdpGalCount');
    var barre = null, bNum = null;
    if (gal && gal.parentElement) {
      if (compteur) compteur.style.display = 'none';
      barre = document.createElement('div');
      barre.className = 'pdp-galbar';
      bNum = document.createElement('span');
      bNum.className = 'pdp-galbar__n';
      barre.appendChild(bNum);
      gal.parentElement.appendChild(barre);
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        ['‹', '›'].forEach(function (sym, k) {
          var f = document.createElement('button');
          f.type = 'button';
          f.className = 'pdp-galnav pdp-galnav--' + (k ? 'next' : 'prev');
          f.setAttribute('aria-label', k ? 'Photo suivante' : 'Photo précédente');
          f.textContent = sym;
          f.style.cssText = 'position:absolute;top:50%;' + (k ? 'right' : 'left') + ':12px;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.92);box-shadow:0 1px 6px rgba(0,0,0,.18);font-size:26px;line-height:1;cursor:pointer;z-index:3;color:#000;';
          f.addEventListener('click', function () {
            var total = nbVues(), pas = pasLargeur();
            var i = Math.round(gal.scrollLeft / pas);
            var cible = k ? i + 1 : i - 1;
            if (cible < 0) cible = total - 1;
            if (cible > total) cible = 0;
            gal.scrollTo({ left: cible * pas, behavior: 'smooth' });
          });
          if (window.getComputedStyle(gal.parentElement).position === 'static') gal.parentElement.style.position = 'relative';
          gal.parentElement.appendChild(f);
        });
      }
      // L'index reste tenu a jour par l'ecouteur de defilement plus bas.
      gal.__i = 0;
    }

    // Largeur d'un pas de defilement. Ce n'est plus celle de la piste : une
    // vue n'occupe que 88 % de la largeur, pour laisser depasser la suivante
    // et signaler qu'il y a autre chose a voir. On mesure donc la figure elle
    // meme, gouttiere comprise, plutot que de recopier le 88 % du CSS ici --
    // deux endroits a tenir en accord finissent toujours par diverger.
    function pasLargeur() {
      if (!gal) return 1;
      var f = gal.children[0];
      if (!f) return gal.clientWidth || 1;
      var st = window.getComputedStyle(gal);
      var gap = parseFloat(st.columnGap || st.gap) || 0;
      return f.getBoundingClientRect().width + gap || gal.clientWidth || 1;
    }

    function majCompteur() {
      if (!gal) return;
      // La copie de bouclage ne compte pas : la galerie annonce 6 vues, pas 7.
      var total = nbVues();
      var largeur = pasLargeur();
      var brut = gal.__i != null ? gal.__i : Math.round(gal.scrollLeft / largeur);
      var i = Math.min(total, (brut % total) + 1);
      if (compteur) compteur.textContent = i + '/' + total;
      if (barre) {
        barre.style.display = total > 1 ? '' : 'none';
        bNum.textContent = i + '/' + total;
      }
    }
    // Premier affichage : sans cet appel le compteur restait vide tant que
    // l'on n'avait pas change de coloris, peindre() etant le seul a l'appeler.
    boucler();
    majCompteur();

    if (gal) {
      gal.addEventListener('scroll', function () {
        if (gal.__t) return;
        gal.__t = requestAnimationFrame(function () {
          gal.__t = null;
          // glissement a la main : on resynchronise l'index sur la position
          gal.__i = Math.round(gal.scrollLeft / pasLargeur());
          majCompteur();
          // Repos sur la copie ? On revient au debut. Le saut attend l'arret
          // du geste (150 ms sans nouvel evenement), sinon il se produirait au
          // milieu du glissement et le rendrait saccade.
          clearTimeout(gal.__fin);
          gal.__fin = setTimeout(function () {
            var total = nbVues();
            if (total < 2 || gal.__i < total) return;
            // scroll-behavior est a smooth pour les autres deplacements : on
            // le neutralise le temps du saut, qui doit etre imperceptible.
            var avant = gal.style.scrollBehavior;
            gal.style.scrollBehavior = 'auto';
            gal.scrollLeft = 0;
            gal.style.scrollBehavior = avant;
            gal.__i = 0;
            majCompteur();
          }, 150);
        });
      }, { passive: true });
    }

    var colorSel = $('#colorSelect', root);
    if (colorSel) {
      state.color = colorSel.value || state.color;
      colorSel.addEventListener('change', function () {
        choisirColoris(Number(colorSel.options[colorSel.selectedIndex].dataset.i || 0), true);
      });
    }

    // Vignettes de coloris facon on.com : elles ne remplacent pas le <select>,
    // elles le pilotent. Un clic passe par choisirColoris(), qui aligne la
    // galerie, le libelle, la pastille active et le <select> d'un seul geste.
    var swBtns = $$('.pdp-sw__i', root);
    if (swBtns.length) {
      swBtns.forEach(function (btn) {
        // La pastille repeint la galerie elle-meme. Elle passait auparavant
        // par le <select>, en posant selectedIndex puis en rejouant 'change' :
        // des que le select comptait moins d'options que de pastilles -- le
        // cas de 132 fiches clonees, qui gardaient les trois coloris du
        // modele -- l'index tombait hors bornes et le clic restait sans effet.
        // Les fiches sont realignees, mais la galerie ne depend plus de cet
        // alignement pour fonctionner.
        btn.addEventListener('click', function () {
          choisirColoris(Number(btn.dataset.i || 0), true);
        });
      });
    }

    // --- Le coloris choisi vit dans l'URL --------------------------------
    //
    // Choisir un coloris ne laissait aucune trace : on passait au deuxieme, on
    // actualisait, et la fiche repartait du premier. Or une variante EST le
    // produit que l'on regarde : c'est elle que l'on veut retrouver apres un
    // F5, et elle que l'on veut envoyer quand on partage le lien. Le coloris
    // part donc dans l'URL, sous la forme « ?coloris=<slug> », et il est relu
    // a l'ouverture de la page.
    //
    // Pourquoi la chaine de requete plutot qu'un « #fragment » : le fragment
    // est deja le mecanisme d'ancrage du navigateur. Ecrire « #black-white »
    // ferait chercher un element de cet identifiant, sauter dedans, et
    // ecraserait toute ancre reelle -- le site en a (le pied, le guide des
    // tailles). Le parametre, lui, ne coute rien ici : le site est servi en
    // statique, « /produits/x/?coloris=y » sert exactement le meme fichier que
    // « /produits/x/ », et les fiches portent deja un <link rel="canonical">
    // sans parametre, donc aucune page dupliquee n'apparait pour les moteurs.
    // Le <script type="application/ld+json"> ne lit pas l'URL : il n'est pas
    // concerne.
    var PARAM_COLORIS = 'coloris';

    // Le slug est celui du catalogue -- celui-la meme qui nomme les images --
    // pose sur la pastille et sur l'option par _tools/coloris_dans_url.py. On
    // ne slugifie surtout PAS le libelle affiche : il est traduit en francais
    // sur une partie des fiches (« Ivoire / Heron » pour ivory-heron), et deux
    // fiches du meme coloris donneraient deux URL differentes. A defaut
    // d'attribut -- une regeneration des vignettes pourrait l'effacer -- on
    // relit le slug dans le nom de fichier de la premiere image du jeu, ou il
    // figure deja.
    function slugColoris(i) {
      var btn = swBtns[i];
      if (btn && btn.getAttribute('data-coloris')) return btn.getAttribute('data-coloris');
      var opt = colorSel && colorSel.options[i];
      if (opt && opt.getAttribute('data-coloris')) return opt.getAttribute('data-coloris');
      var jeu = galerie[i];
      var src = jeu && jeu.images && jeu.images[0];
      if (!src) return '';
      return String(src).split('/').pop().replace(/-\d+\.[a-z0-9]+$/i, '');
    }

    function nbColoris() {
      return Math.max(galerie.length, swBtns.length, colorSel ? colorSel.options.length : 0);
    }

    // history.replaceState et non pushState : changer de coloris n'est pas une
    // navigation, c'est un reglage de la page ou l'on se trouve deja. Avec
    // pushState, essayer cinq coloris poserait cinq entrees d'historique et
    // « Precedent » ferait reculer de coloris en coloris au lieu de ramener au
    // rayon d'ou l'on vient : l'internaute serait pris au piege de sa propre
    // hesitation. Avec replaceState la fiche n'occupe qu'une entree, le retour
    // arriere ramene bien au rayon, et cette entree garde tout de meme le
    // coloris -- y revenir plus tard le retrouve.
    function majURL(i) {
      if (!window.history || !history.replaceState) return;
      var slug = slugColoris(i);
      var u;
      try { u = new URL(location.href); } catch (e) { return; }
      // Le coloris de depart n'est pas ecrit : l'URL nue reste celle de la
      // fiche, celle du canonical et du plan de site. Le parametre n'apparait
      // que lorsqu'il dit quelque chose, et il s'efface des que l'on revient
      // au premier coloris.
      if (i > 0 && slug) u.searchParams.set(PARAM_COLORIS, slug);
      else u.searchParams.delete(PARAM_COLORIS);
      try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    }

    // Un seul chemin pour changer de coloris : le clic sur une pastille, le
    // menu deroulant et la relecture de l'URL passent tous par ici. Sans quoi
    // l'un d'eux finit toujours par oublier une piece -- la galerie sans le
    // libelle, ou la pastille sans le <select> qui alimente le panier.
    function choisirColoris(i, ecrireURL) {
      var jeu = galerie[i];
      var lib = (jeu && (jeu.label || jeu.color)) ||
        (swBtns[i] && swBtns[i].getAttribute('title')) ||
        (colorSel && colorSel.options[i] && colorSel.options[i].value) || '';
      if (lib) {
        state.color = lib;
        var nom = $('#colorName', root);
        if (nom) nom.textContent = lib;
      }
      swBtns.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      // Le select reste la source du coloris pour le panier : on l'aligne
      // quand l'option existe.
      if (colorSel && colorSel.options.length > i) colorSel.selectedIndex = i;
      peindre(i);
      if (ecrireURL) majURL(i);
    }

    // Relecture au chargement : F5, lien partage, ou retour arriere sur une
    // entree qui portait deja un coloris.
    (function coloriDeLURL() {
      var demande = new URLSearchParams(location.search).get(PARAM_COLORIS);
      if (!demande) return;
      var cible = -1;
      for (var k = 0; k < nbColoris(); k++) {
        if (slugColoris(k) === demande) { cible = k; break; }
      }
      if (cible < 0) {
        // Coloris inconnu : lien vieilli, faute de frappe, coloris retire du
        // catalogue. On ne casse rien -- la fiche reste sur son coloris de
        // depart -- et on retire le parametre, pour que l'URL cesse d'annoncer
        // un coloris qui n'est pas a l'ecran.
        majURL(0);
        return;
      }
      // L'URL dit deja ce qu'il faut : on ne la reecrit pas.
      choisirColoris(cible, false);
    })();

    // Coloris replies sur une seule rangee au mobile et sur tablette.
    // Treize vignettes occupaient trois rangees et repoussaient la taille et
    // le bouton d'achat hors de l'ecran. On n'en garde donc qu'une rangee, et
    // le compteur cesse d'annoncer le total pour annoncer le RESTE : « +8
    // coloris », sur lequel on appuie pour tout deplier.
    //
    // Le nombre de vignettes qui tiennent n'est pas fixe -- il depend de la
    // largeur de l'ecran et du nombre de coloris. On le mesure donc plutot
    // que de le presumer : toutes les vignettes sont revelees, on lit leur
    // offsetTop, et celles qui ne partagent pas celui de la premiere sont
    // passees a la ligne, donc masquees.
    (function coloriosSurUneRangee() {
      var sw = $('.pdp-sw', root);
      var lab = $('.pdp-opt__n', root);
      if (!sw || !lab || swBtns.length < 2) return;
      var total = swBtns.length;
      var deplie = false;

      function appliquer() {
        swBtns.forEach(function (b) { b.hidden = false; });
        if (window.innerWidth >= 1000 || deplie) {
          lab.textContent = total + ' coloris';
          lab.classList.toggle('pdp-opt__n--plus', deplie);
          return;
        }
        var premiere = swBtns[0].offsetTop;
        var tiennent = swBtns.filter(function (b) {
          return b.offsetTop === premiere;
        }).length;
        // La pastille du coloris affiche ne doit jamais tomber dans la partie
        // repliee. En arrivant par une URL qui porte un coloris de la deuxieme
        // rangee, on verrait sinon la bonne galerie et le bon libelle sans
        // qu'aucune pastille visible ne soit active : la fiche aurait l'air de
        // se contredire. L'internaute a demande ce coloris, on le lui montre.
        var iActif = -1;
        swBtns.forEach(function (b, k) { if (b.classList.contains('is-active')) iActif = k; });
        if (iActif >= tiennent) { deplie = true; appliquer(); return; }
        if (tiennent >= total) {
          lab.textContent = total + ' coloris';
          lab.classList.remove('pdp-opt__n--plus');
          return;
        }
        swBtns.forEach(function (b, i) { b.hidden = i >= tiennent; });
        lab.textContent = 'Voir les ' + total + ' coloris';
        lab.classList.add('pdp-opt__n--plus');
        lab.setAttribute('role', 'button');
        lab.setAttribute('tabindex', '0');
      }

      lab.addEventListener('click', function () {
        if (window.innerWidth >= 1000) return;
        deplie = !deplie;
        appliquer();
      });
      lab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lab.click(); }
      });
      var minuteur;
      window.addEventListener('resize', function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(appliquer, 150);
      });
      appliquer();
    })();
    var sel = $('#sizeSelect', root);
    if (sel) {
      sel.addEventListener('change', function () {
        state.size = sel.value || null;
        sel.classList.toggle('is-set', Boolean(state.size));
        // La ligne d'aide a ete retiree des fiches (bloc_achat_pdp.py) : la
        // bulle et le bouton se suivent directement. La garde evite une
        // TypeError a chaque changement de taille sur un element absent.
        var hint = $('#sizeHint', root);
        if (hint) {
          hint.textContent = state.size
            ? 'Pointure EU ' + state.size + ' sélectionnée'
            : 'Chaussant standard — voir le guide des tailles en cas de doute';
        }
      });
    }

    $('#addBtn').addEventListener('click', function () {
      if (!state.size) {
        toast('Choisis ta pointure');
        var wrap = $('.sizes', root);
        if (wrap) {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          wrap.classList.add('sizes--ask');
          setTimeout(function () { wrap.classList.remove('sizes--ask'); }, 1600);
        }
        var sl = $('#sizeSelect', root);
        if (sl) setTimeout(function () { sl.focus(); }, 400);
        return;
      }
      var shownImg = ($('#pdpMain') && $('#pdpMain').getAttribute('src')) || data.image;
      add({
        slug: data.slug, name: data.model, image: shownImg,
        size: state.size, color: state.color, price: data.price, sale: data.sale, ref: data.ref, qty: 1,
        coloris: (function () { var b = document.querySelector('.pdp-sw__i.is-active'); return b ? b.getAttribute('data-coloris') : ''; })(),
      });
    });

    var buybar = $('#buybar');
    var addBtnEl = $('#addBtn');
    if (buybar && addBtnEl) {
      var enAttente = false;
      function majBuybar() {
        enAttente = false;
        buybar.classList.toggle('show', addBtnEl.getBoundingClientRect().bottom < 70);
      }
      window.addEventListener('scroll', function () {
        if (enAttente) return;
        enAttente = true;
        requestAnimationFrame(majBuybar);
      }, { passive: true });
      majBuybar();
      var bb = $('#buybarBtn');
      var bbSel = $('#buybarSize');
      if (bbSel && sel) {
        bbSel.innerHTML = sel.innerHTML;
        // La barre n'a pas la largeur de la fiche. « Selectionnez une taille »
        // mesure 144px dans la police On pour 142px utiles dans le select :
        // la derniere lettre etait coupee sur ordinateur, et sur telephone le
        // select ne prend que la moitie d'une ligne -- il en manquait bien
        // plus. On raccourcit la seule option vide, et seulement sur la copie
        // de la barre : le select de la fiche garde sa phrase entiere, il a
        // toute la largeur qu'il lui faut.
        var vide = bbSel.querySelector('option[value=""]');
        if (vide) vide.textContent = 'Choisir la taille';
        bbSel.addEventListener('change', function () {
          sel.value = bbSel.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        sel.addEventListener('change', function () {
          if (bbSel.value !== sel.value) bbSel.value = sel.value;
        });
      }
      if (bb) bb.addEventListener('click', function () {
        if (!state.size && bbSel) {
          buybar.classList.add('need-size');
          bbSel.focus();
          if (typeof bbSel.showPicker === 'function') { try { bbSel.showPicker(); } catch (e) {} }
          toast('Choisis ta pointure');
          return;
        }
        buybar.classList.remove('need-size');
        addBtnEl.click();
      });
    }

    track('ViewContent', { value: data.price, id: data.slug });
  }

  
  function initPLP() {
    var grid = $('#plpGrid');
    if (!grid) return;
    var cards = $$('[data-cat]', grid);
    var more = $('#plpMore');
    var PAS = 24;
    // Ordre d'origine du HTML : sert de reference au tri "Notre selection",
    // et evite de reconstruire la grille quand on revient a ce tri.
    cards.forEach(function (c, i) { c.dataset.rang = i; });

    var etat = { tri: 'selection', genre: [], cat: [], taille: [], famille: [], visibles: PAS };
    // Le mega-menu renvoie vers /homme/?modele=cloudmonster : on applique
    // le filtre a l'arrivee plutot que de creer une page par famille.
    var qs = new URLSearchParams(location.search).get('modele');
    if (qs) etat.famille = qs.split(',').filter(Boolean);
    // 16/09 : les filtres et le tri vivent dans l'URL. Sans cela, revenir
    // d'une fiche par le bouton Precedent rendait la liste complete.
    (function lireFiltresURL() {
      var u = new URLSearchParams(location.search);
      ['genre', 'cat', 'taille', 'famille'].forEach(function (k) {
        var v = u.get(k);
        if (v) etat[k] = v.split(',').filter(Boolean);
      });
      var t = u.get('tri');
      if (t) etat.tri = t;
      var n = parseInt(u.get('vus'), 10);
      if (n > 0) etat.visibles = n;
      try {
        syncCases();
        var r = document.querySelector('#plpPanneau input[name="plpTri"][value="' + etat.tri + '"]');
        if (r) r.checked = true;
      } catch (e) {}
    })();
    var LIBELLES = { running: 'Running', tennis: 'Tennis',
                     outdoor: 'Randonnée', lifestyle: 'Lifestyle' };

    function actifs() {
      return etat.genre.length + etat.cat.length + etat.taille.length + etat.famille.length;
    }

    function correspond(c) {
      // Une carte des huit pages d'activite tous genres vaut pour PLUSIEURS
      // fiches du meme modele : elle ouvre la fiche homme mais represente
      // aussi la femme, et porte alors data-genres="Homme Femme". Comparer
      // data-gender -- le genre de la seule fiche ouverte -- effacait de la
      // grille, quand on cochait « Femme », les 38 modeles de /running/ que
      // la marque vend aux deux. Repli sur data-gender partout ailleurs.
      if (etat.genre.length) {
        var g = (c.dataset.genres || c.dataset.gender || '').split(' ');
        var vu = etat.genre.some(function (v) { return g.indexOf(v) >= 0; });
        if (!vu) return false;
      }
      if (etat.cat.length && etat.cat.indexOf(c.dataset.cat) < 0) return false;
      if (etat.famille.length && etat.famille.indexOf(c.dataset.famille) < 0) return false;
      if (etat.taille.length) {
        var t = (c.dataset.tailles || '').split(' ');
        // une seule pointure suffit : l'utilisateur cherche ce qui lui va
        var ok = etat.taille.some(function (x) { return t.indexOf(x) >= 0; });
        if (!ok) return false;
      }
      return true;
    }

    function ordonner(liste) {
      var l = liste.slice();
      if (etat.tri === 'prix-asc' || etat.tri === 'prix-desc') {
        var sens = etat.tri === 'prix-asc' ? 1 : -1;
        l.sort(function (a, b) {
          return (parseFloat(a.dataset.prix || 0) - parseFloat(b.dataset.prix || 0)) * sens;
        });
      } else if (etat.tri === 'nouveau') {
        var neuf = function (c) {
          return /nouveau|nouvelle/i.test(c.dataset.badge || '') ? 0 : 1;
        };
        l.sort(function (a, b) {
          return neuf(a) - neuf(b) || (a.dataset.rang - b.dataset.rang);
        });
      } else {
        l.sort(function (a, b) { return a.dataset.rang - b.dataset.rang; });
      }
      return l;
    }

    function pills() {
      var zone = $('#fltrApplique');
      var hote = $('#fltrPills');
      if (!zone || !hote) return;
      hote.textContent = '';
      var tout = [];
      etat.genre.forEach(function (v) { tout.push(['genre', v, v]); });
      etat.cat.forEach(function (v) { tout.push(['cat', v, LIBELLES[v] || v]); });
      etat.taille.forEach(function (v) { tout.push(['taille', v, 'EU ' + v]); });
      etat.famille.forEach(function (v) {
        tout.push(['famille', v, v.charAt(0).toUpperCase() + v.slice(1)]);
      });
      tout.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fltr-pill';
        var lib = document.createElement('span');
        lib.textContent = f[2];
        var croix = document.createElement('i');
        croix.setAttribute('aria-hidden', 'true');
        croix.textContent = '×';
        b.appendChild(lib);
        b.appendChild(croix);
        b.setAttribute('aria-label', 'Retirer le filtre ' + f[2]);
        b.addEventListener('click', function () {
          etat[f[0]] = etat[f[0]].filter(function (x) { return x !== f[1]; });
          syncCases();
          etat.visibles = PAS;
          rendre();
        });
        hote.appendChild(b);
      });
      zone.hidden = tout.length === 0;
    }

    function syncCases() {
      $$('#plpPanneau input[type="checkbox"]').forEach(function (i) {
        i.checked = etat[i.dataset.f].indexOf(i.value) >= 0;
      });
    }

    function majBouton() {
      var b = $('#plpFiltres');
      if (!b) return;
      var pan = $('#plpPanneau');
      var ouvert = pan && !pan.hidden;
      var n = actifs();
      var lib = (ouvert ? 'Cacher les filtres' : 'Afficher filtres') + (n ? ' (' + n + ')' : '');
      // Selon la page, le libelle est dans #plpFiltresTxt ou .plp-bar__txt.
      // Ecrire dans le bouton entier effacerait son pictogramme.
      var txt = b.querySelector('.plp-bar__txt') || document.getElementById('plpFiltresTxt');
      if (txt) txt.textContent = lib; else b.textContent = lib;
      b.setAttribute('aria-expanded', String(ouvert));
    }

    // L'URL suit l'etat de la liste, sans creer d'entree d'historique :
    // changer un filtre n'est pas une navigation, mais Precedent depuis une
    // fiche doit retrouver la liste telle qu'elle etait.
    function ecrireFiltresURL() {
      if (!window.history || !history.replaceState) return;
      try {
        var u = new URL(location.href);
        [['genre', etat.genre], ['cat', etat.cat], ['taille', etat.taille], ['famille', etat.famille]]
          .forEach(function (p) {
            if (p[1] && p[1].length) u.searchParams.set(p[0], p[1].join(','));
            else u.searchParams.delete(p[0]);
          });
        if (etat.tri && etat.tri !== 'selection') u.searchParams.set('tri', etat.tri);
        else u.searchParams.delete('tri');
        if (etat.visibles > PAS) u.searchParams.set('vus', etat.visibles);
        else u.searchParams.delete('vus');
        u.searchParams.delete('modele');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    function rendre() {
      var gardees = cards.filter(correspond);
      var ordre = ordonner(gardees);
      // On repositionne dans le DOM plutot que de recreer : les images
      // deja chargees le restent, et le tri ne provoque aucun clignotement.
      ordre.forEach(function (c) { grid.appendChild(c); });
      cards.forEach(function (c) { c.style.display = 'none'; });
      ordre.slice(0, etat.visibles).forEach(function (c) { c.style.display = ''; });

      var total = ordre.length;
      var label = $('#plpCount');
      if (label) {
        var n = document.createElement('b');
        n.textContent = total;
        var mot = document.createElement('i');
        mot.textContent = 'résultat' + (total > 1 ? 's' : '');
        label.textContent = '';
        label.appendChild(n);
        label.appendChild(mot);
      }
      if (more) {
        var reste = total - Math.min(total, etat.visibles);
        more.style.display = reste > 0 ? '' : 'none';
        // Libelle sec, comme chez On : le nombre restant figure deja
        // dans le compteur de resultats juste au-dessus de la grille.
        more.textContent = 'Voir plus';
      }
      pills();
      majBouton();
      ecrireFiltresURL();
    }

    // --- Panneau : ouverture, tri, cases, remise a zero ---

    var panneau = $('#plpPanneau');
    var bouton = $('#plpFiltres');
    function basculer(force) {
      if (!panneau) return;
      panneau.hidden = force !== undefined ? force : !panneau.hidden;
      // La classe va sur body ET sur <html> : html porte overflow-x: hidden,
      // ce qui empeche l'overflow de body de remonter au viewport. Sans la
      // classe sur la racine, le verrou de defilement du tiroir mobile ne
      // prend pas et la page continue de filer sous le panneau.
      document.body.classList.toggle('a-filtres', !panneau.hidden);
      document.documentElement.classList.toggle('a-filtres', !panneau.hidden);
      majBouton();
    }
    if (bouton) bouton.addEventListener('click', function () { basculer(); });
    var fermer = $('#fltrFermer');
    if (fermer) fermer.addEventListener('click', function () { basculer(true); });

    // Filet de securite : Echap ferme le panneau. Le keydown global n'appelle
    // que closeAll(), qui ne connait que le panier et le menu ; on ne le
    // touche pas pour ne pas melanger les deux fermetures.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!panneau || panneau.hidden) return;
      basculer(true);
    });
    // Sur mobile le panneau couvre tout l'ecran : un clic sur son fond, hors
    // de tout controle, le referme comme un clic sur le voile d'un tiroir.
    if (panneau) panneau.addEventListener('click', function (e) {
      if (e.target === panneau) basculer(true);
    });
    // Passage desktop <-> mobile panneau ouvert : la colonne de gauche
    // devient un tiroir opaque plein ecran que rien ne refermait. On ferme
    // au franchissement du point de rupture.
    var mq = window.matchMedia('(max-width: 899.98px)');
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (panneau && !panneau.hidden) basculer(true);
      });
    } else if (mq.addListener) {
      mq.addListener(function () {
        if (panneau && !panneau.hidden) basculer(true);
      });
    }

    $$('#plpPanneau input[name="plpTri"]').forEach(function (r) {
      r.addEventListener('change', function () {
        etat.tri = r.value;
        etat.visibles = PAS;
        rendre();
      });
    });
    $$('#plpPanneau input[type="checkbox"]').forEach(function (i) {
      i.addEventListener('change', function () {
        var l = etat[i.dataset.f];
        if (i.checked) { if (l.indexOf(i.value) < 0) l.push(i.value); }
        else { etat[i.dataset.f] = l.filter(function (x) { return x !== i.value; }); }
        etat.visibles = PAS;
        rendre();
      });
    });
    var clear = $('#fltrClear');
    if (clear) clear.addEventListener('click', function () {
      etat.genre = []; etat.cat = []; etat.taille = []; etat.famille = [];
      etat.tri = 'selection';
      var r = $('#plpPanneau input[name="plpTri"][value="selection"]');
      if (r) r.checked = true;
      syncCases();
      etat.visibles = PAS;
      rendre();
    });

    // Onglets d'activite conserves : ils naviguent vers la page dediee, mais
    // d'anciennes pages portent encore des boutons a data-filter.
    $$('.chip[data-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = chip.dataset.filter;
        etat.cat = v === 'all' ? [] : [v];
        syncCases();
        etat.visibles = PAS;
        $$('.chip[data-filter]').forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        rendre();
      });
    });

    // Chips de genre (pages outlet / nouveautes / collections) : ils etaient
    // poses sans handler, donc cliquer ne filtrait rien. Selection multiple,
    // alignee sur le tableau etat.genre que rendre() applique deja ; aucun genre
    // coche = tous affiches.
    $$('.chip[data-gender]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = chip.dataset.gender;
        var i = etat.genre.indexOf(v);
        if (i < 0) etat.genre.push(v); else etat.genre.splice(i, 1);
        chip.setAttribute('aria-pressed', String(i < 0));
        syncCases();
        etat.visibles = PAS;
        rendre();
      });
    });

    if (more) {
      more.addEventListener('click', function () {
        etat.visibles += PAS;
        rendre();
        $$('img[loading="lazy"]', grid).forEach(function (im) {
          if (im.getBoundingClientRect().top < window.innerHeight * 3) im.loading = 'eager';
        });
      });
    }
    rendre();
  }

  
  window.nlSubmit = function (form, e) {
    if (e) e.preventDefault();
    var input = form.querySelector('input');
    var email = ((input && input.value) || '').trim();
    if (!email) return false;
    fetch('/api/send/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shopId: SHOP.shopId, email: email }),
    })
      .then(function (r) {
        if (r.ok) {
          try { form.reset(); } catch (e) {}
          if (input) input.placeholder = 'Inscription enregistrée';
          toast('Inscription enregistrée');
        } else {
          toast('Inscription momentanément indisponible');
        }
      })
      .catch(function () { toast('Inscription momentanément indisponible'); });
    return false;
  };

  
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function absolute(src) {
    try { return new URL(src, location.origin).href; } catch (e) { return src; }
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('#cartBtn')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('#burger')) { e.preventDefault(); $('#mnav').classList.add('open'); $('#scrim').classList.add('open'); return; }
    if (t.closest('#scrim') || t.closest('[data-close]')) { closeAll(); return; }
    if (t.closest('#coBtn')) { e.preventDefault(); checkout(); return; }
    // Retour a la page d'ou l'on vient. `history.length > 1` ecarte le seul
    // cas ou le retour arriere sortirait du site : un onglet ouvert
    // directement sur /panier/ (lien partage, favori). Le repli est
    // l'accueil, pas une page de vente en particulier.
    if (t.closest('#continuerBtn')) {
      e.preventDefault();
      var venu = '';
      try { venu = document.referrer ? new URL(document.referrer).host : ''; } catch (e2) {}
      if (venu === location.host && history.length > 1) history.back(); else location.href = '/collections/running-sur-route';
      return;
    }
    var q = t.closest('[data-q]');
    if (q) { setQty(q.closest('.line').dataset.key, Number(q.dataset.q)); return; }
    if (t.closest('.line-rm')) { remove(t.closest('.line').dataset.key); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  
  window.Cart = {
    items: function () { relire(); return cart.slice(); },
    total: function () { relire(); return subtotal(); },
    count: function () { relire(); return count(); },
    checkout: checkout,
  };

  
  function initRails() {
    $$('[data-rail]').forEach(function (wrap) {
      var rail = $('.rail', wrap);
      var bar = $('.rail-bar i', wrap);
      if (!rail || !bar) return;

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = rail.clientWidth / rail.scrollWidth;
        var pos = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        bar.style.left = pos * (100 - Math.max(ratio * 100, 8)) + '%';
      }
      // Les deux fleches du carrousel des familles (page d'accueil). Elles sont
      // facultatives : un rail qui n'en porte pas garde le comportement d'avant.
      // Le pas est la largeur visible moins un chevauchement, pour qu'on ne
      // perde jamais la carte qu'on regardait.
      var prev = $('[data-rail-prev]', wrap);
      var next = $('[data-rail-next]', wrap);

      function bornes() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max - 2;
      }
      function pousser(sens) {
        rail.scrollBy({ left: sens * Math.max(rail.clientWidth - 60, 120),
                        behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { pousser(-1); });
      if (next) next.addEventListener('click', function () { pousser(1); });

      rail.addEventListener('scroll', function () { sync(); bornes(); },
                            { passive: true });
      window.addEventListener('resize', function () { sync(); bornes(); });
      sync();
      bornes();
    });
  }

  
  
  
  function initAnnonce() {
    var msgs = $$('.annonce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3000);
  }

  function initMenu() {
    var nav = $('#mnav');
    if (!nav) return;
    function montrer(nom) {
      $$('.mnav__panel', nav).forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.panel === nom);
      });
      nav.scrollTop = 0;
    }
    $$('[data-open]', nav).forEach(function (b) {
      b.addEventListener('click', function () { montrer(b.dataset.open); });
    });
    $$('[data-back]', nav).forEach(function (b) {
      b.addEventListener('click', function () { montrer('root'); });
    });
    // Les deux boutons de la barre du bas. Ils ferment le menu avant d'ouvrir
    // ce qu'ils appellent : le drawer et le panneau de recherche se posent
    // au-dessus de lui, le laisser ouvert dessous le ferait reapparaitre a la
    // fermeture.
    var mc = $('#mnavCart');
    if (mc) mc.addEventListener('click', function () { closeAll(); openDrawer(); });
    var ms = $('#mnavSearch');
    if (ms) ms.addEventListener('click', function () {
      closeAll();
      var loupe = $('#searchBtn');
      if (loupe) loupe.click();
    });

    var scrim = $('#scrim');
    if (scrim) scrim.addEventListener('click', function () { setTimeout(function () { montrer('root'); }, 300); });
  }

  // Recherche. Le bouton loupe existait dans les 255 pages sans etre branche
  // sur quoi que ce soit : ni gestionnaire, ni panneau, ni donnees. Il ne
  // faisait rien depuis le debut.
  //
  // Le panneau est construit ici plutot que pose dans les 255 pages : il ne
  // sert qu'a ceux qui cliquent, et le fabriquer en JS evite d'alourdir chaque
  // page d'un balisage inerte. L'index n'est telecharge qu'au PREMIER clic,
  // puis garde en memoire.
  function initRecherche() {
    var btn = $('#searchBtn');
    if (!btn) return;
    var panneau = null, champ = null, resultats = null, index = null, chargement = null;

    function normaliser(s) {
      // Sans accents ni casse : « cloudtilt » doit trouver « Cloudtilt », et
      // « femme » trouver « Femme ».
      return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function construire() {
      panneau = document.createElement('div');
      panneau.className = 'rech';
      panneau.id = 'rech';
      panneau.innerHTML =
        '<div class="rech__in">' +
          '<div class="rech__bar">' +
            '<svg class="rech__loupe" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>' +
            '<input type="search" id="rechInput" autocomplete="off" placeholder="Rechercher un modèle" aria-label="Rechercher un modèle">' +
            '<button type="button" class="rech__close" data-rech-close aria-label="Fermer la recherche">' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="rech__res" id="rechRes"></div>' +
        '</div>';
      document.body.appendChild(panneau);
      champ = $('#rechInput', panneau);
      resultats = $('#rechRes', panneau);

      champ.addEventListener('input', function () { rendre(champ.value); });
      panneau.addEventListener('click', function (e) {
        if (e.target.closest('[data-rech-close]') || e.target === panneau) fermer();
      });
    }

    function charger() {
      if (index) return Promise.resolve(index);
      if (chargement) return chargement;
      chargement = fetch((window.__HK && window.__HK.recherche) || '')
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (d) { index = d; return index; })
        .catch(function () { index = []; return index; });
      return chargement;
    }

    function rendre(q) {
      var mots = normaliser(q).split(/\s+/).filter(Boolean);
      if (!mots.length) {
        resultats.innerHTML = '<p class="rech__vide">Tapez le nom d’un modèle, une activité ou un genre.</p>';
        return;
      }
      // Un produit sort s'il contient TOUS les mots saisis : « cloud femme »
      // ne doit pas ramener tous les Cloud ni toutes les femmes.
      var trouves = (index || []).filter(function (p) {
        var foin = normaliser(p.n + ' ' + p.d + ' ' + p.g + ' ' + p.c);
        return mots.every(function (m) { return foin.indexOf(m) !== -1; });
      });
      if (!trouves.length) {
        resultats.innerHTML = '<p class="rech__vide">Aucun modèle ne correspond à « ' + esc(q) + ' ».</p>';
        return;
      }
      var haut = trouves.slice(0, 24);
      resultats.innerHTML =
        '<p class="rech__n">' + trouves.length + (trouves.length > 1 ? ' modèles' : ' modèle') + '</p>' +
        '<div class="rech__grille">' + haut.map(function (p) {
          return '<a class="rech__item" href="/products/' + esc(p.id) + '">' +
            '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="120" height="120">' +
            '<span class="rech__nom">' + esc(p.n) + '</span>' +
            '<span class="rech__desc">' + esc(p.d) + '</span>' +
            '<span class="rech__prix">' + money(p.p) + '</span></a>';
        }).join('') + '</div>' +
        (trouves.length > haut.length
          ? '<p class="rech__vide">… et ' + (trouves.length - haut.length) + ' autres. Affinez votre recherche.</p>'
          : '');
    }

    function ouvrir() {
      if (!panneau) construire();
      panneau.classList.add('open');
      document.body.style.overflow = 'hidden';
      rendre('');
      champ.value = '';
      champ.focus();
      charger().then(function () { rendre(champ.value); });
    }

    function fermer() {
      if (!panneau) return;
      panneau.classList.remove('open');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', function (e) { e.preventDefault(); ouvrir(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });
  }

  function initHeader() {
    var hdr = $('#hdr');
    if (!hdr || !hdr.classList.contains('hdr--over')) return;
    var hero = $('.hero');
    var trigger = hero ? hero.offsetHeight - 90 : 200;
    function onScroll() {
      hdr.classList.toggle('is-solid', window.scrollY > trigger);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  
  function initLazyBoost() {
    var rows = $$('.shelf, .rail, .cats-row, .pcards');
    if (!rows.length || !('IntersectionObserver' in window)) {
      $$('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        $$('img[loading="lazy"]', e.target).forEach(function (im) { im.loading = 'eager'; });
        io.unobserve(e.target);
      });
    }, { rootMargin: '300px 0px' });
    rows.forEach(function (r) { io.observe(r); });
  }

  // Coeur des favoris. Un favori qui disparait au rechargement ne vaut rien :
  // l'etat est garde en local, comme le panier.
  var FAV_KEY = 'cloudstep_favoris_v1';

  function favorisLus() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; }
    catch (e) { return []; }
  }

  function initFavoris() {
    var coeurs = $$('.card__fav');
    if (!coeurs.length) return;
    var liste = favorisLus();

    coeurs.forEach(function (coeur) {
      var carte = coeur.closest('a.card');
      var ref = carte && carte.getAttribute('href');
      if (!ref) return;

      if (liste.indexOf(ref) !== -1) {
        coeur.setAttribute('aria-pressed', 'true');
        coeur.setAttribute('aria-label', 'Retirer des favoris');
      }

      coeur.addEventListener('click', function (e) {
        // La carte entiere est un lien : sans ca, mettre en favori ouvrirait
        // la fiche produit.
        e.preventDefault();
        e.stopPropagation();

        var actifs = favorisLus();
        var i = actifs.indexOf(ref);
        var ajoute = i === -1;
        if (ajoute) actifs.push(ref); else actifs.splice(i, 1);
        try { localStorage.setItem(FAV_KEY, JSON.stringify(actifs)); } catch (err) {}

        // Un meme produit apparait sur plusieurs pages et parfois deux fois sur
        // la meme : on aligne tous ses coeurs, pas seulement celui clique.
        $$('.card__fav').forEach(function (autre) {
          var c = autre.closest('a.card');
          if (!c || c.getAttribute('href') !== ref) return;
          autre.setAttribute('aria-pressed', String(ajoute));
          autre.setAttribute('aria-label', ajoute ? 'Retirer des favoris' : 'Ajouter aux favoris');
        });
      });
    });
  }

  // Depliant "Afficher filtres" des pages de listing. Il n'est pose sur la page
  // que lorsqu'il a reellement quelque chose a montrer.

  // Series de coloris sous les cartes : la piste defile, et les fleches
  // n'apparaissent que si elle deborde vraiment. On ne peut pas le decider a la
  // generation du HTML, la largeur disponible dependant du rendu.
  function initSwatches() {
    var blocs = $$('.swatches');
    if (!blocs.length) return;

    function ajuster(bloc) {
      var piste = $('.swatches__piste', bloc);
      // Carte masquee par un filtre : les mesures valent zero, toute decision
      // prise maintenant serait fausse.
      if (!piste || !piste.clientWidth) return;

      var deborde = piste.scrollWidth - piste.clientWidth > 1;
      var prev = $('.sw-nav--prev', bloc);
      var next = $('.sw-nav--next', bloc);
      [prev, next].forEach(function (f) { if (f) f.hidden = !deborde; });
      if (!deborde) return;

      var reste = piste.scrollWidth - piste.clientWidth - piste.scrollLeft;
      if (prev) prev.setAttribute('aria-disabled', String(piste.scrollLeft <= 1));
      if (next) next.setAttribute('aria-disabled', String(reste <= 1));
    }

    blocs.forEach(function (bloc) {
      var piste = $('.swatches__piste', bloc);
      if (!piste) return;

      $$('.sw-nav', bloc).forEach(function (fleche) {
        fleche.addEventListener('click', function (e) {
          // Toute la carte est un lien : sans ca, un clic sur la fleche
          // ouvrirait la fiche produit au lieu de faire defiler.
          e.preventDefault();
          e.stopPropagation();
          if (fleche.getAttribute('aria-disabled') === 'true') return;
          var sens = fleche.classList.contains('sw-nav--prev') ? -1 : 1;
          var pas = Math.max(110, Math.round(piste.clientWidth * 0.8));
          piste.scrollBy({ left: sens * pas, behavior: 'smooth' });
        });
      });

      piste.addEventListener('scroll', function () { ajuster(bloc); });
      ajuster(bloc);

      // Une carte revenant d'un filtre passe d'une largeur nulle a sa largeur
      // reelle : c'est ce moment-la qu'il faut saisir pour mesurer.
      if (window.ResizeObserver) {
        new ResizeObserver(function () { ajuster(bloc); }).observe(piste);
      }
    });

    if (!window.ResizeObserver) {
      var minuteur;
      window.addEventListener('resize', function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () { blocs.forEach(ajuster); }, 150);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    paint();
    initPDP();
    initPLP();
    initFavoris();
    initSwatches();
    initRails();
    initHeader();
    initRecherche();
    initMenu();
    initAnnonce();
    initLazyBoost();
    track('PageView', {});
  });
})();
// Conseil de taille et réassurance visibles sur la fiche, sans ouvrir l'accordéon (analyse PostHog 07/09 : « Taille et coupe » est le 3e clic des fiches).
(function(){
  function go(){
    var sizes=document.querySelector('.sizes'); if(!sizes || document.querySelector('.size-hint-auto')) return;
    var txt='';
    document.querySelectorAll('.pdp-acc details').forEach(function(d){ var s=d.querySelector('summary'); if(s && /taille et coupe/i.test(s.textContent)){ var p=d.querySelector('p'); if(p){ var t=p.textContent.replace(/\s+/g,' ').trim(); var m=t.match(/^(.*?[.!])\s(.*?[.!])?/); txt=m?((m[1]||'')+' '+(m[2]||'')).replace(/Correspondances.*$/,'').trim():t; } } });
    if(txt){ var h=document.createElement('p'); h.className='size-hint-auto'; h.style.cssText='margin:2px 0 8px;font-size:13px;line-height:1.45;color:#444;'; h.textContent=txt; sizes.parentNode.insertBefore(h,sizes); }
    if(!document.querySelector('.size-reassure-auto')){ var sr=document.createElement('p'); sr.className='size-reassure-auto'; sr.style.cssText='margin:8px 0 0;font-size:13px;line-height:1.45;color:#666;'; sr.textContent='Pas la bonne pointure ? Retour sous 14 jours, livraison offerte.'; sizes.parentNode.insertBefore(sr,sizes.nextSibling); }
    var btn=document.getElementById('addBtn');
    if(btn && !document.querySelector('.pdp-reassure-auto')){ var r=document.createElement('p'); r.className='pdp-reassure-auto'; r.style.cssText='margin:10px 0 0;font-size:13px;line-height:1.5;color:#555;text-align:center;'; r.textContent='Livraison offerte en France · 14 jours pour changer d’avis · Paiement sécurisé'; btn.parentNode.insertBefore(r,btn.nextSibling); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
})();


// QA 9 (15/09) : les boutons « i » des caracteristiques n'avaient que l'attribut title,
// invisible au toucher. Un clic ouvre l'explication sous la caracteristique.
document.addEventListener('click', function (e) {
  var bt = e.target.closest ? e.target.closest('.pdp-on-i') : null;
  document.querySelectorAll('.pdp-on-i-pop').forEach(function (p) {
    if (!bt || p.previousElementSibling !== bt.closest('.pdp-on-spec__lab')) p.remove();
  });
  if (!bt) return;
  e.preventDefault();
  var lab = bt.closest('.pdp-on-spec__lab') || bt.parentNode;
  var suiv = lab.nextElementSibling;
  if (suiv && suiv.classList.contains('pdp-on-i-pop')) { suiv.remove(); bt.setAttribute('aria-expanded', 'false'); return; }
  var txt = bt.getAttribute('data-aide') || bt.getAttribute('title') || '';
  if (!txt) return;
  if (!bt.getAttribute('data-aide')) { bt.setAttribute('data-aide', txt); bt.removeAttribute('title'); }
  var pop = document.createElement('p');
  pop.className = 'pdp-on-i-pop';
  pop.setAttribute('role', 'note');
  pop.style.cssText = 'margin:8px 0 0;padding:10px 12px;background:#f2f2f2;border-radius:8px;font-size:13px;line-height:1.45;color:#222;font-weight:400;text-transform:none;letter-spacing:0;';
  pop.textContent = txt;
  lab.parentNode.insertBefore(pop, lab.nextSibling);
  bt.setAttribute('aria-expanded', 'true');
});

// Page favoris (16/09). Les coeurs des cartes ecrivaient deja dans
// localStorage ; il manquait l'endroit ou les retrouver. La liste est
// reconstruite depuis data/recherche.json, la meme source que la recherche.
(function favorisPage() {
  var FAV_KEY = 'cloudstep_favoris_v1';
  function lus() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function lien() {
    // Un lien vers les favoris dans le pied de page et dans le menu mobile,
    // pose ici pour ne pas toucher aux 272 pages.
    var cibles = [];
    var ft = document.querySelector('.ft-nav, .ft ul, footer ul');
    if (ft) cibles.push(ft);
    var premier = document.querySelector('#mnav a[href]');
    if (premier && premier.parentNode) cibles.push(premier.parentNode);
    cibles.forEach(function (ul) {
      if (ul.querySelector('a[href="/favoris/"]')) return;
      var li = document.createElement(ul.tagName === 'UL' ? 'li' : 'div');
      var a = document.createElement('a');
      a.href = '/pages/favoris';
      a.textContent = 'Mes favoris';
      li.appendChild(a);
      ul.appendChild(li);
    });
  }
  function money(n) { return Number(n).toFixed(2).replace('.', ',') + ' €'; }
  function rendre(grille, produits) {
    var liste = lus();
    if (!liste.length) {
      grille.innerHTML = '<div class="empty"><p>Aucun favori pour le moment.</p>' +
        '<a class="btn" href="/collections/running-sur-route" style="margin-top:16px;display:inline-flex">Découvrir la collection</a></div>';
      return;
    }
    var par = {};
    produits.forEach(function (p) { par['/products/' + p.id] = p; });
    var html = liste.map(function (href) {
      var p = par[href];
      if (!p) return '';
      return '<a class="card" href="' + href + '" data-cat="' + (p.c || '') + '">' +
        '<div class="card__media"><img src="' + p.i + '" alt="' + p.n + '" loading="lazy"></div>' +
        '<div class="card__body"><div class="card__name">' + p.n + '</div>' +
        '<div class="card__meta">' + (p.d || p.g || '') + '</div>' +
        '<div class="price"><b>' + money(p.p) + '</b></div></div></a>';
    }).join('');
    grille.innerHTML = html || '<div class="empty"><p>Aucun favori pour le moment.</p></div>';
  }
  lien();
  var grille = document.getElementById('favGrid');
  if (!grille) return;
  fetch((window.__HK && window.__HK.recherche) || '')
    .then(function (r) { return r.json(); })
    .then(function (d) { rendre(grille, d); })
    .catch(function () {
      grille.innerHTML = '<div class="empty"><p>Impossible de charger vos favoris pour le moment.</p></div>';
    });
})();

// Fiche epuisee (16/09) : quand aucune pointure n'est disponible, la fiche se
// verrouille. Le bouton d'ajout et celui de la barre du bas passent en
// « Épuisé », et l'etiquette orange du systeme existant s'affiche sous le prix.
(function ficheEpuisee() {
  var sel = document.getElementById('sizeSelect');
  if (!sel) return;
  var dispo = [].slice.call(sel.options).filter(function (o) { return o.value && !o.disabled; });
  if (dispo.length) return;
  ['addBtn', 'buybarBtn'].forEach(function (id) {
    var b = document.getElementById(id);
    if (!b) return;
    b.disabled = true;
    b.textContent = 'Épuisé';
  });
  var bb = document.getElementById('buybarSize');
  if (bb) bb.disabled = true;
  var info = document.querySelector('.pdp-info');
  if (info && !document.querySelector('.pdp-rupture--epuise')) {
    var p = document.createElement('p');
    p.className = 'pdp-rupture pdp-rupture--epuise';
    p.textContent = 'Épuisé';
    var btn = document.getElementById('addBtn');
    if (btn) btn.parentNode.insertBefore(p, btn); else info.appendChild(p);
  }
})();

// Panier accessible depuis la barre d'achat (16/09). Sur une fiche mobile, la
// barre d'achat recouvre la barre du bas : l'icone panier de l'en-tete devenait
// inatteignable des le premier defilement. Le bouton est donc ajoute dans la
// barre elle meme, devant la pointure.
(function panierDansBuybar() {
  var barre = document.getElementById('buybar');
  if (!barre) return;
  var dedans = barre.querySelector('.buybar__in') || barre;
  if (dedans.querySelector('.buybar__cart')) return;
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'icon-btn buybar__cart';
  b.setAttribute('aria-label', 'Voir mon panier');
  b.style.cssText = 'flex:none;padding:8px;position:relative';
  b.innerHTML = '<svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9.5 8V6.5a2.5 2.5 0 0 1 5 0V8"/></svg><span class="cart-count" style="display:none">0</span>';
  b.addEventListener('click', function (e) {
    e.preventDefault();
    var d = document.getElementById('drawer'), sc = document.getElementById('scrim');
    if (d) d.classList.add('open');
    if (sc) sc.classList.add('open');
  });
  dedans.insertBefore(b, dedans.firstChild);
  // Le compteur du panier est repeint par paint() sur tous les .cart-count.
  var n = document.querySelector('.cart-count');
  if (n) {
    var c = b.querySelector('.cart-count');
    c.textContent = n.textContent;
    c.style.display = n.style.display;
  }
})();

// Urgence panier (17/09/2026) : le bandeau noir du panier affiche un compte a
// rebours reel jusqu'a minuit (heure de Paris) et le pied du panier rappelle
// que le panier est reserve 10 minutes. Aucun prix ni remise touche.
(function () {
  var st = document.createElement('style');
  st.textContent = '.urg-cd{font-variant-numeric:tabular-nums;font-weight:700;letter-spacing:0}' +
    '.dft-resa{margin:0 0 10px;font-size:13px;line-height:1.35;text-align:center;color:var(--ink)}' +
    '.dft-resa b{font-variant-numeric:tabular-nums}';
  document.head.appendChild(st);
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function parisNow() {
    try {
      var p = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = +x.value; });
      return (o.hour % 24) * 3600 + o.minute * 60 + o.second;
    } catch (e) { var d = new Date(); return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds(); }
  }
  function leftMidnight() {
    var r = Math.min(86399, 86400 - parisNow());
    return pad(Math.floor(r / 3600)) + ':' + pad(Math.floor(r % 3600 / 60)) + ':' + pad(r % 60);
  }
  var RESA = 600, KEY = 'on_resa_t0';
  function leftResa() {
    var t0 = 0, now = Date.now();
    try { t0 = +localStorage.getItem(KEY) || 0; } catch (e) {}
    if (!t0 || now - t0 >= RESA * 1000) { t0 = now; try { localStorage.setItem(KEY, String(t0)); } catch (e) {} }
    var r = Math.max(0, RESA - Math.floor((now - t0) / 1000));
    return pad(Math.floor(r / 60)) + ':' + pad(r % 60);
  }
  function tick() {
    var promos = document.querySelectorAll('.drawer-promo');
    for (var i = 0; i < promos.length; i++) {
      var el = promos[i], cd = el.querySelector('.urg-cd');
      if (!cd) { el.innerHTML = 'Offre -50&nbsp;% : se termine dans <span class="urg-cd"></span>'; cd = el.querySelector('.urg-cd'); }
      var v1 = leftMidnight(); if (cd.textContent !== v1) cd.textContent = v1;
    }
    var btns = document.querySelectorAll('#coBtn');
    for (var j = 0; j < btns.length; j++) {
      var b = btns[j], prev = b.previousElementSibling;
      if (!prev || !prev.classList.contains('dft-resa')) {
        var p = document.createElement('p'); p.className = 'dft-resa';
        p.innerHTML = 'Ton panier est réservé pendant <b class="urg-resa"></b>';
        b.parentNode.insertBefore(p, b); prev = p;
      }
      var rz = prev.querySelector('.urg-resa'), v2 = leftResa(); if (rz.textContent !== v2) rz.textContent = v2;
    }
  }
  tick(); setInterval(tick, 1000);
  // Le panier est redessine a chaque +, - ou Supprimer : on repasse tout de
  // suite pour que le decompte et la reservation ne clignotent pas.
  var busy = false;
  try {
    new MutationObserver(function () {
      if (busy) return; busy = true;
      try { tick(); } finally { busy = false; }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
